module.exports = __webpack_public_path__ + "static/img/profilePicture.c06ead1.png";